import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Global flag to track popstate events
let isPopStateNavigation = false;

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const isInitialMount = useRef(true);

  useEffect(() => {
    // Enable browser's native scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto';
    }

    // Set up global popstate listener once
    const handlePopState = () => {
      isPopStateNavigation = true;
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    // Skip scroll behavior on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Small delay to check if this was popstate navigation
    const timeoutId = setTimeout(() => {
      if (!isPopStateNavigation) {
        // This was programmatic navigation, scroll to top
        window.scrollTo(0, 0);
      }
      // Reset flag for next navigation
      isPopStateNavigation = false;
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
